import { render } from "./BalModal.vue?vue&type=template&id=4eb06532&scoped=true&ts=true"
import script from "./BalModal.vue?vue&type=script&lang=ts"
export * from "./BalModal.vue?vue&type=script&lang=ts"

import "./BalModal.vue?vue&type=style&index=0&id=4eb06532&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eb06532"]])

export default __exports__